import CustomHead from 'components/commons/CustomHead'
import PrivacyContact from 'components/privacy/agreement/contact'

const AgreementContact: React.FC = () => {
  return (
    <div>
      <CustomHead
        keyword={''}
        image={'https://aitria.co.jp/img/ogp_logo.png'}
        url={'https://aitria.co.jp/agreement/contact/'}
        title="お問い合わせにおける個人情報の取り扱いについて | Aitria（アイトリア）"
        description=""
        noindexNofollow={true}
      />
      <PrivacyContact />
    </div>
  )
}

export default AgreementContact
